




























































import {
  Prop,
  Vue,
  Component,
} from "@/shared/vuepack";
import moment from "moment";
import _ from "lodash";
import {
  Transaction,
  TransactionSource,
  Expense
} from "@/shared/types";
import Pill from "@/shared/components/ui/Pill.vue";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import ReimbursedExpenseChildRow from "@/shared/components/expense/ReimbursedExpenseChildRow.vue";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

@Component({
  components: {
    Pill,
    CurrencyAmount,
    ReimbursedExpenseChildRow
  }
})
export default class TransactionListItem extends Vue {
  custodianSettingsStore = useCustodianSettingsStore();

  @Prop()
  transaction: Transaction;

  @Prop()
  expenses: Expense[];

  isOpen = false;

  getPillType (item): string {
    if (item.moneyIncreasing) {
      return "green-bg";
    }
    return "red-bg";
  }

  toggleOpen (): void {
    if (this.hasExpenses) {
      this.isOpen = !this.isOpen;
    }
  }

  get hasExpenses (): boolean {
    return this.custodianSettingsStore.showChildExpenseRows && !!this.transactionExpenses.length;
  }

  get transactionExpenses (): Expense[] {
    return this.expenses ? this.expenses : [];
  }

  get formattedDate (): string {
    return moment(this.transaction.postedDate).format("MMM D, YYYY");
  }

  get subTitle (): string {
    if (this.transaction.source === TransactionSource.Reimbursement ||
        this.transaction.source === TransactionSource.DebitCard ||
        this.transaction.source === TransactionSource.Disbursement) {

      if (!this.custodianSettingsStore.showChildExpenseRows) {
        return "";
      }

      const len = this.transactionExpenses.length;
      return `${len} expense${len === 1 ? `` : `s`}`;
    }

    return this.transaction.displaySource;
  }

  get displayUnaccountedExpenseRow (): boolean {

    // display if there are no child expenses, or the child expenses don't equal the reimbursed amount
    return (!this.transactionExpenses.length ||
        _.round(_.sumBy(this.transactionExpenses, "reimbursedAmount"), 2) !== this.transaction.amount * -1);
  }

  get unaccountedExpenseProps (): object {
    const reimbursedAmount = this.transaction.amount +
        _.round(_.sumBy(this.transactionExpenses, "reimbursedAmount"), 2);

    return {
      name: "Undocumented Amount",
      expenseCategory: "medical",
      reimbursedAmount,
      date: this.transaction.postedDate,
      id: 0
    };
  }

  get hidePill (): boolean {
    return this.transaction.source === TransactionSource.None
        || this.transaction.source === TransactionSource.Interest
        || this.transaction.source === TransactionSource.InterestReversal
        || this.transaction.source === TransactionSource.Transfer;
  }
}
